import * as React from 'react';
import { useEffect } from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { useDispatch, useSelector } from 'react-redux';
import Spinner from 'react-bootstrap/Spinner';
import { fetchDataloggers, selectDataloggers } from '../features/dataloggerList/dataloggersSlice';
import { useTranslation } from 'react-i18next';

import DataloggerList from '../features/dataloggerList/DataloggerList';
import Breadcrumbs from '../components/layout/Breadcrumbs';
import Subheader from '../components/layout/Subheader';
import Panel from '../components/layout/Panel';
import DataloggerMap from '../features/dataloggerMap/DataloggerMap';
import { RootState } from '../app/rootReducer';

const DataloggerListPage: React.FC = () => {
  const isLoading = useSelector((state: any) => state.dataloggers.isLoading);
  const dataloggers = useSelector(selectDataloggers);
  const user = useSelector(
    (state: RootState) => state.authentication.user
  );

  const { t } = useTranslation();

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchDataloggers());
  }, [dispatch]);

  let defaultCoordinates = [0, 0];
  if (dataloggers.length === 1 && dataloggers[0].lon !== null && dataloggers[0].lat !== null) {
    // if the user only has one logger, we might as well center to it
    defaultCoordinates = [dataloggers[0].lon, dataloggers[0].lat];
  } else if (user?.username === 'pasi' || user?.username === 'impala') {
    // silly hack -- show CANADA to canada people/companies
    defaultCoordinates = [-89.63271, 49.152123];
  }

  return (
    <div>
      <Breadcrumbs />
      <Subheader>{t('Monitoring stations')}</Subheader>
      {isLoading ? (
        <Spinner animation="border" />
      ) : (
        <Row>
          <Col xl="6">
            <Panel>
              {(dataloggers.length > 0) && (
                <DataloggerMap
                  dataloggers={dataloggers}
                  coordinates={defaultCoordinates}
                />
              )}
            </Panel>
          </Col>
          <Col xl="6">
            <Panel>
              <DataloggerList dataloggers={dataloggers} />
            </Panel>
          </Col>
        </Row>
      )}
    </div>
  );
};
export default DataloggerListPage;
